<template>
  <div class="commonGuidePage" v-if="guidePageShow">
    <swiper ref="guidePageSwiper" :options="swiperOptions">
      <swiper-slide v-for="(item, index) in imageList" :key="index">
        <img :src="item">
      </swiper-slide>
      <swiper-slide />
      <div class="swiper-pagination" slot="pagination" />
      <div class="swiper-button-prev switchBtn" slot="button-prev">
        <i class="iconfont icon-shangyiye" />
      </div>
      <div class="swiper-button-next switchBtn" slot="button-next">
        <i class="iconfont icon-xiayiye" />
      </div>
    </swiper>
    <div class="closeBtn" @click="closeBtn">跳过</div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        effect: 'fade',
        speed: 100,
        on: {
          reachEnd: () => {
            this.$emit('closeHandlen');
          }
        }
      }
    };
  },
  props: {
    imageList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    guidePageShow: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    guidePageShow (val) {
      if (val) {
        this.removeSwiperLastElement();
      }
    }
  },
  methods: {
    closeBtn () {
      this.$emit('closeHandlen');
    },
    removeSwiperLastElement () {
      this.$nextTick(() => {
        let swiperPagination = document.getElementsByClassName('swiper-pagination')[0];
        let bullets = swiperPagination.getElementsByClassName('swiper-pagination-bullet');
        swiperPagination.removeChild(bullets[bullets.length - 1]);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.commonGuidePage {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 150;
  background: #ffffff;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .64);
  }

  > .closeBtn {
    width: 100px;
    background: #ffffff;
    border-radius: 20px;
    text-align: center;
    line-height: 42px;
    position: absolute;
    top: 30px;
    right: 40px;
    z-index: 100;
    cursor: pointer;
  }

  ::v-deep.swiper-container {
    height: 100%;

    > .swiper-wrapper {
      .swiper-slide {
        width: 100%;

        > img {
          width: 100%;
        }
      }
    }

    .switchBtn {
      width: 60px;
      height: 60px;
      background: #919191;
      border-radius: 50%;
      color: #ffffff;
      text-align: center;
    }

    .swiper-pagination {
      bottom: 34px;

      .swiper-pagination-bullet {
        width: 14px;
        height: 14px;
        background: #919191;
        opacity: 1;
        margin: 0 10px;
      }

      .swiper-pagination-bullet-active {
        background: #3384FE;
      }
    }

    .swiper-button-prev {
      top: auto;
      bottom: 20px;
      left: 50%;
      transform: translateX(-200px);

      &:after {
        content: '';
      }
    }

    .swiper-button-next {
      top: auto;
      bottom: 20px;
      right: 50%;
      transform: translateX(200px);

      &:after {
        content: '';
      }
    }
  }
}
</style>
